var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52582_837)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8018 15.4856C14.9823 15.4711 15.1578 15.4172 15.3159 15.3274C15.5031 15.2211 15.6596 15.0681 15.7701 14.8833C15.8806 14.6986 15.9415 14.4885 15.9469 14.2733C15.9523 14.0582 15.9021 13.8452 15.801 13.6552L9.07285 1.15632L9.07236 1.15542C8.96525 0.957397 8.80671 0.791863 8.61332 0.676433C8.41992 0.560997 8.19892 0.500001 7.97365 0.500001C7.74837 0.500001 7.52737 0.560997 7.33397 0.676433C7.14058 0.791863 6.98204 0.957397 6.87493 1.15542L6.87439 1.1564L0.147411 13.6591L0.146269 13.6612C0.0452043 13.8512 -0.00502059 14.0642 0.000393237 14.2793C0.00580709 14.4945 0.06668 14.7046 0.177191 14.8893C0.287708 15.0741 0.444143 15.2271 0.631395 15.3334C0.818655 15.4397 1.03029 15.4957 1.24567 15.4957L14.7016 15.4957C14.7359 15.4957 14.7694 15.4922 14.8018 15.4856Z",
    fill: "#DC0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47559 12.4964C6.47559 11.6708 7.14377 10.9966 7.97403 10.9966C8.80428 10.9966 9.47247 11.6708 9.47247 12.4964C9.47247 13.3221 8.80428 13.9963 7.97403 13.9963C7.14377 13.9963 6.47559 13.3221 6.47559 12.4964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97363 10.4969L6.97363 4.49854L8.97363 4.49854L8.97363 10.4969L6.97363 10.4969Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52582_837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorStatus);
export default __webpack_public_path__ + "static/media/errorStatus.0dfac6322e59e2541c9aaae41b474961.svg";
export { ForwardRef as ReactComponent };